import { useRef, useEffect, useCallback } from 'react';

/**
 * Get whether a component has mounted.
 * @returns boolean
 */ const useMounted = ()=>{
    const isMounted = useRef(false);
    useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return useCallback(()=>isMounted.current, [])();
};

export { useMounted };
//# sourceMappingURL=use-mounted.js.map
